import axios from "axios";
import { API_CONFIG } from "../utils/constants";

const API_URL = `${API_CONFIG.BASE_URL}/api`;

// Configurar axios con el token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/**
 * Servicio de API para auditoría y sesiones
 */
const auditService = {
  // ==========================================
  // LOGS DE AUDITORÍA
  // ==========================================

  /**
   * Obtener logs de auditoría con filtros
   */
  async getLogs(filters = {}) {
    const response = await axios.get(
      `${API_URL}/audit/logs`,
      {
        params: filters,
        ...getAuthHeaders(),
      }
    );
    return response.data;
  },

  /**
   * Obtener estadísticas de auditoría
   */
  async getStats(filters = {}) {
    const response = await axios.get(
      `${API_URL}/audit/stats`,
      {
        params: filters,
        ...getAuthHeaders(),
      }
    );
    return response.data;
  },

  /**
   * Obtener historial de un recurso
   */
  async getResourceHistory(resource, resourceId) {
    const response = await axios.get(
      `${API_URL}/audit/resource/${resource}/${resourceId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  /**
   * Obtener actividad de un usuario
   */
  async getUserActivity(userId, days = 30) {
    const response = await axios.get(
      `${API_URL}/audit/user/${userId}`,
      {
        params: { days },
        ...getAuthHeaders(),
      }
    );
    return response.data;
  },

  // ==========================================
  // SESIONES
  // ==========================================

  /**
   * Obtener sesiones activas
   */
  async getActiveSessions() {
    const response = await axios.get(
      `${API_URL}/audit/sessions/active`,
      getAuthHeaders()
    );
    return response.data;
  },

  /**
   * Obtener estadísticas de sesiones
   */
  async getSessionStats(filters = {}) {
    const response = await axios.get(
      `${API_URL}/audit/sessions/stats`,
      {
        params: filters,
        ...getAuthHeaders(),
      }
    );
    return response.data;
  },

  /**
   * Actualizar actividad de sesión
   */
  async updateSessionActivity(sessionId, page) {
    const response = await axios.post(
      `${API_URL}/audit/sessions/${sessionId}/activity`,
      { page },
      getAuthHeaders()
    );
    return response.data;
  },

  /**
   * Finalizar sesión
   */
  async endSession(sessionId) {
    const response = await axios.post(
      `${API_URL}/audit/sessions/${sessionId}/end`,
      {},
      getAuthHeaders()
    );
    return response.data;
  },
};

export default auditService;
